/* global axios */

import ApiClient from './ApiClient';

class NucleoWorkOrdersAPI extends ApiClient {
  constructor() {
    super('nucleo_work_orders', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  counts(params = {}) {
    return axios.get(`${this.url}/counts`, { params });
  }

  filterCatalog(params = {}) {
    return axios.get(`${this.url}/filter_catalog`, { params });
  }

  detail(listingId, orderId) {
    return axios.get(`${this.url}/${listingId}/orders/${orderId}`);
  }

  markViewed(listingId, orderId) {
    return axios.post(`${this.url}/${listingId}/orders/${orderId}/view`);
  }

  schedule(listingId, orderId, payload = {}) {
    return axios.post(
      `${this.url}/${listingId}/orders/${orderId}/schedule`,
      payload
    );
  }

  start(listingId, orderId, payload = {}) {
    return axios.post(
      `${this.url}/${listingId}/orders/${orderId}/start`,
      payload
    );
  }

  addEvidence(
    listingId,
    orderId,
    {
      files = [],
      document_artifact_ids: documentArtifactIds = [],
      ...payload
    } = {}
  ) {
    const formData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        formData.append(key, value);
      }
    });
    files.forEach(file => formData.append('files[]', file));
    documentArtifactIds.forEach(id =>
      formData.append('document_artifact_ids[]', id)
    );

    return axios.post(
      `${this.url}/${listingId}/orders/${orderId}/add_evidence`,
      formData
    );
  }

  addPaymentDocument(
    listingId,
    orderId,
    { kind, file, idempotency_key: idempotencyKey } = {}
  ) {
    const formData = new FormData();
    formData.append('kind', kind);
    formData.append('files[]', file);
    if (idempotencyKey) formData.append('idempotency_key', idempotencyKey);

    return axios.post(
      `${this.url}/${listingId}/orders/${orderId}/add_payment_document`,
      formData
    );
  }

  complete(listingId, orderId, payload = {}) {
    return axios.post(
      `${this.url}/${listingId}/orders/${orderId}/complete`,
      payload
    );
  }

  accept(listingId, orderId, payload = {}) {
    return axios.post(
      `${this.url}/${listingId}/orders/${orderId}/accept`,
      payload
    );
  }
}

export default new NucleoWorkOrdersAPI();
